import { fetchWithAuth } from "./api";
import { Psychologist, PsychologistResponse } from "types/psychologist";

export const psychologistService = {
  getAll: async (): Promise<PsychologistResponse> => {
    return (await fetchWithAuth("/psychologists")) as PsychologistResponse;
  },

  toggleActive: async (
    psychologistId: number
  ): Promise<{ success: boolean; message: string }> => {
    return await fetchWithAuth(
      `/api/psychologists/${psychologistId}/toggle-active`,
      {
        method: "PATCH",
      }
    );
  },

  create: async (data: any): Promise<{ success: boolean; message: string }> => {
    return await fetchWithAuth("/psychologists", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  update: async (
    id: number,
    data: any
  ): Promise<{ success: boolean; message: string }> => {
    return await fetchWithAuth(`/psychologists/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },
};
